import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import FlightBookingFlow from '../../components/FlightBookingFlow/FlightBookingFlow';

const FlightBookingFlowPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-grow">
        <FlightBookingFlow />
      </main>
    </div>
  );
};

export default FlightBookingFlowPage;
